function Error() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="14px">
      <path
        fill="white"
        fillRule="evenodd"
        d="M8,1C4.1,1 1,4.1 1,8C1,11.9 4.1,15 8,15C11.9,15 15,11.9 15,8C15,4.1 11.9,1 8,1ZM10.7,11.5L8,8.8L5.3,11.5L4.5,10.7L7.2,8L4.5,5.3L5.3,4.5L8,7.2L10.7,4.5L11.5,5.3L8.8,8L11.5,10.7L10.7,11.5Z"
      />
    </svg>
  );
}

export default Error;
